<template>
    <v-btn class="attack-direction-btn" depressed tile :class="team.isActive ? 'activeDirection' : 'inactiveDirection'" @click="changeDirection(team.component.direction)" :disabled="gamefinished || isDisabled">
        <div v-if="direction === 'left'" class="direction-icon-holder">
            <svg class="arrow-icon" width="35" height="20" viewBox="0 0 28 16" xmlns="http://www.w3.org/2000/svg"><path d="m20 0 8 8-8 8v-4.9798759h-8v-6.00031255h8zm-10 5v6h-2v-6zm-4 0v6h-2v-6zm-4 0v6h-2v-6z"/></svg>
        </div>
        <div v-if="direction === 'right'" class="direction-icon-holder">
            <svg class="arrow-icon" width="35" height="20" viewBox="0 0 28 16" xmlns="http://www.w3.org/2000/svg"><path d="m8 0v5.01981155h8v6.00031255h-8v4.9798759l-8-8zm20 5v6h-2v-6zm-4 0v6h-2v-6zm-4 0v6h-2v-6z"/></svg>
        </div>
    </v-btn>
</template>

<script>
    import eventBus from '@/eventBus';
    import CONSTANTS from "@/constants";

    export default {
        name: "AttackDirection",
        props: {
            team: Object,
            direction: String,
            gamefinished: Boolean,
            isDisabled: Boolean
        },
        methods: {
            changeDirection: function(direction) {
                eventBus.$emit(CONSTANTS.EVENTS.CHANGE.DIRECTION, direction);
                eventBus.$emit(CONSTANTS.EVENTS.RECORD.CREATED, {
                    action: 'cancelled',
                    params: {
                        selectedAction: null,
                        selectedTeamId: null,
                        selectedPlayer: null,
                        selectedArea: null,
                        selectedGateArea: 0,
                    }
                });
            }
        },
    }
</script>

<style scoped>
    button.attack-direction-btn {
        display: flex;
        flex-flow: row;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex-wrap: nowrap;
        border-width: 1px;
        border-style: solid;
        height: 43px;
        min-height: 43px;
        min-width: 70px;
        width: 70px;
        padding: 0 !important;
    }

    .arrow-icon {
        display: block;
    }

    .theme--light.activeDirection {
        pointer-events: none;
        background-color: #000000 !important;
        border-color: #000000 !important;
    }

    .theme--light.inactiveDirection {
        background-color: #ffffff !important;
        border-color: #ececec !important;
    }

    .theme--dark.activeDirection {
        pointer-events: none;
        background-color: #ffffff !important;
        border-color: #ffffff !important;
    }

    .theme--dark.inactiveDirection {
        background-color: #262830 !important;
        border-color: #2d303e !important;
    }

    .theme--light.activeDirection svg {
        fill: #ffffff;
    }

    .theme--light.inactiveDirection svg {
        fill: #aaaaaa;
    }

    .theme--dark.activeDirection svg {
        fill: #1e2028;
    }

    .theme--dark.inactiveDirection svg {
        fill: #9298af;
    }
</style>
